import { POLICY_SECTIONS, isFieldRequired, isFieldVisible } from '../../config/policyFieldConfig';

function FieldInput({ field, value, onChange, providers, required }) {
  const common = {
    className: 'input-field',
    value: value ?? '',
    onChange: (e) => {
      const v = field.type === 'boolean' ? e.target.checked : e.target.value;
      onChange(field.key, v);
    },
  };

  if (field.type === 'boolean') {
    return (
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" checked={Boolean(value)} onChange={common.onChange} className="rounded border-slate-300" />
        {field.label}
      </label>
    );
  }

  if (field.type === 'textarea') {
    return <textarea {...common} rows={3} required={required} />;
  }

  if (field.type === 'select') {
    return (
      <select {...common} required={required}>
        {field.options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    );
  }

  if (field.type === 'provider') {
    return (
      <select {...common} required={required}>
        <option value="">Select provider</option>
        {providers.map((p) => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </select>
    );
  }

  const inputType = field.type === 'date' ? 'date' : field.type === 'number' || field.type === 'currency' || field.type === 'percent' ? 'number' : 'text';
  return <input type={inputType} {...common} required={required} step={field.type === 'percent' ? '0.1' : undefined} />;
}

export default function PolicyForm({ form, onChange, providers, onSubmit, onCancel, submitLabel = 'Save Policy' }) {
  return (
    <form onSubmit={onSubmit} className="space-y-8">
      {POLICY_SECTIONS.map((section) => {
        const visibleFields = section.fields.filter((f) => isFieldVisible(f, form));
        if (visibleFields.length === 0) return null;

        return (
          <div key={section.id} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-slate-900">{section.title}</h3>
              {section.description && <p className="text-sm text-slate-500">{section.description}</p>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {visibleFields.map((field) => {
                const required = isFieldRequired(field, form);
                return (
                  <div key={field.key} className={field.col === 2 ? 'md:col-span-2' : field.col === 3 ? 'md:col-span-3' : ''}>
                    {field.type !== 'boolean' && (
                      <label className="label">{field.label}{required ? ' *' : ''}</label>
                    )}
                    <FieldInput
                      field={field}
                      value={form[field.key]}
                      onChange={(key, val) => onChange({ ...form, [key]: val })}
                      providers={providers}
                      required={required}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      <div className="flex flex-wrap gap-3 sticky bottom-4 bg-slate-50/90 backdrop-blur p-4 rounded-xl border border-slate-200">
        <button type="submit" className="btn-primary">{submitLabel}</button>
        {onCancel && <button type="button" className="btn-secondary" onClick={onCancel}>Cancel</button>}
      </div>
    </form>
  );
}
